import { Router } from "../router";

export const router = new Router<any>();

router.on("watch_event", (_data, ctx) => {
    ctx.git.handleWatchEvent();
});
